import { ComposerModeMenu } from './ComposerModeMenu';
import { ComposerModelMenu } from './ComposerModelMenu';
import { ComposerProfileChip } from './ComposerProfileChip';
import { ComposerProfileMenu } from './ComposerProfileMenu';
import type { IComposerControlsConfig } from './types';

interface ComposerFooterControlsProps {
  composerControls: IComposerControlsConfig;
  /** Present once a conversation exists: the agent it was created with, shown as a chip because it
   * can no longer change. Absent on the blank screen, where the agent is still a choice. */
  boundProfile?: { profileKey: string | null };
}

/** The controls inside the composer footer, beside the add menu: agent, mode and model. */
export const ComposerFooterControls = ({
  composerControls,
  boundProfile,
}: ComposerFooterControlsProps) => {
  const { profilePicker, modeConfig, modelConfig } = composerControls;

  return (
    <div className="flex items-center gap-xs">
      {profilePicker &&
        (boundProfile ? (
          <ComposerProfileChip profileKey={boundProfile.profileKey} />
        ) : (
          <ComposerProfileMenu profilePicker={profilePicker} />
        ))}
      {modeConfig && <ComposerModeMenu modeConfig={modeConfig} />}
      {modelConfig &&
        (modelConfig.models.length > 0 ||
          modelConfig.isLoading ||
          Boolean(modelConfig.error)) && (
          <ComposerModelMenu modelConfig={modelConfig} />
        )}
    </div>
  );
};
